<template>
  <v-dialog v-model="dialogStatus" max-width="600" transition="dialog-bottom-transition">
    <v-card class="mx-auto">
      <div class="d-flex align-end my-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">课程信息</span>
      </div>

      <v-form v-model="valid" class="px-12 mt-6">
        <v-text-field v-model="form.name" color="green lighten-1" label="课程名称 *"
          :rules="[(v) => !!v || '课程名称不能为空']"></v-text-field>
        <v-text-field v-model="form.university" color="green lighten-1" label="签约院校 *"
          :rules="[(v) => !!v || '签约院校不能为空']"></v-text-field>
        <v-text-field v-model="form.college" color="green lighten-1" label="学院/系 *"
          :rules="[(v) => !!v || '学院/系不能为空']"></v-text-field>
        <v-text-field v-model="form.major" color="green lighten-1" label="教研团队/专业 *"
          :rules="[(v) => !!v || '教研团队/专业不能为空']"></v-text-field>
        <v-select v-model="form.refer" :items="refer_list" chips multiple color="green lighten-1" item-text="name"
          item-value="value" label="适用" persistent-hint></v-select>
        <v-text-field v-model="form.manager" color="green lighten-1" label="负责人 *" :rules="[(v) => !!v || '负责人不能为空']"
          hint="请负责人先注册为系统用户，并输入负责人的系统用户名"></v-text-field>
        <v-textarea v-model="form.description" color="green lighten-1" label="课程简介" rows="1" auto-grow></v-textarea>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" dark @click.stop="submit">提交</v-btn>
        <v-btn color="gray" @click.stop="$store.dispatch('courseAndProject/reverseShowCourseEdit', 'close')">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    dialogStatus: {
      get() {
        this.$nextTick(() => {
          this.$refs.form?.resetValidation()
        })
        const status = this.$store.state.courseAndProject.showCourseEdit
        if (status === 'edit') {
          this.form = Object.assign({}, this.$store.state.courseAndProject.course)
        } else {
          this.form = {}
        }
        return status === 'edit' || status === 'add'
      },
      set(val) {
        if (!val) {
          this.$store.dispatch('courseAndProject/reverseShowCourseEdit', 'close')
        }
      }
    }
  },
  data() {
    return {
      refer_list: [
        { value: 'bk', name: '本科' },
        { value: 'gz', name: '高职' },
        { value: 'zz', name: '中职' },
        { value: 'gj', name: '技师学院' },
        { value: 'jx', name: '技校' },
        { value: 'qy', name: '企业' },
      ],
      form: {
        required: '',
        name: '',
        university: '',
        college: '',
        refer: [],
        major: '',
        manager: '',
        attachment_url: '',
        description: ''
      },
      valid: false,
    }
  },
  methods: {
    async fileChange(e) {
      console.log('更改文件', e)
    },
    async submit() {
      if (this.valid) {
        this.$store.dispatch('courseAndProject/saveCourse', this.form)
      } else {
        this.$store.commit('global/SHOW_SNACKBAR', { color: 'yellow darken-2', text: '参数校验未通过' })
      }
    },
  }
}
</script>
